import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';

import { ErrorResponse } from '@components/pages/Organization/types';
import { GroupAdminParams, createGroupAdmin } from '@utils/backend-api/group-admins';
import {
  ACTIVE_USERS_KEY,
  ARCHIVED_USERS_KEY,
  ORGANIZATION_DETAILS_KEY,
} from '@utils/backend-api/organizations';

const useGroupAdminCreate = () => {
  const queryClient = useQueryClient();

  return useMutation((params: GroupAdminParams) => createGroupAdmin(params), {
    onSuccess: ({ message }) => {
      toast.success(message);

      queryClient.invalidateQueries([ORGANIZATION_DETAILS_KEY]);
      queryClient.invalidateQueries([ACTIVE_USERS_KEY]);
      queryClient.invalidateQueries([ARCHIVED_USERS_KEY]);
    },
    onError: (e: ErrorResponse) => {
      toast.error(e.message);
    },
  });
};

export default useGroupAdminCreate;
